import {Component} from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import styles from './extended-inspection.module.scss';
import {
    ExtendedInspectionCustomReportParameters,
    ExtendedInspectionScheduledReportParameters,
    InspectionStatus,
    ReportPeriodType,
} from '../../../../../../store/reports';
import {
    ServiceProviderSelection,
    SoldToSelection
} from '../../../../../../store/analytics';
import ServiceProvidersSelectorComponent from '../../../../components/service-providers-selector.component';
import SoldTosSelectorComponent from '../../../../components/sold-tos-selector.component';
import {ServiceProviderSelectionsControlValue} from '../../../../../analytics/dashboard-controls/service-providers-selector/types/service-providers-selections-control-value';
import {SoldToSelectionsControlValue} from '../../../../../analytics/dashboard-controls/sold-tos-selector/types/sold-tos-selections-control-value';

class ExtendedInspectionComponent extends Component<AllProps, AllState> {

    constructor(props) {
        super(props);

        const {parameters} = this.props;

        let inspectionStatus = InspectionStatus.All;
        if (parameters && parameters.inspectionStatus) {
            inspectionStatus = parameters.inspectionStatus;
        }
        let serviceProviders: ServiceProviderSelection = {includes: []};
        if (parameters && parameters.serviceProviders) {
            serviceProviders = parameters.serviceProviders;
        }
        let soldTos: SoldToSelection = {includes: [], includeAll: false};
        if (parameters && parameters.soldTos) {
            soldTos = parameters.soldTos;
        }

        this.state = {
            selectedInspectionStatus: inspectionStatus,
            soldToSelection: new SoldToSelectionsControlValue('', soldTos),
            serviceProviderSelection: new ServiceProviderSelectionsControlValue('', serviceProviders),
        };
    }

    public render(): JSX.Element {
        const {periodType, t} = this.props;
        const {selectedInspectionStatus, soldToSelection,serviceProviderSelection} = this.state;

        return (
            <div className={styles.content}>
                {periodType === ReportPeriodType.Scheduled
                    ? <div className={styles.title}>{t('Parameters')}</div>
                    : null
                }
                <div className={styles.form}>
                    <div className={styles.formRow}>
                        <div className={styles.info}>{t('Select a service provider')}</div>
                        <ServiceProvidersSelectorComponent
                            defaultServiceProviderSelection={serviceProviderSelection && serviceProviderSelection.value.includes.length > 0 ? serviceProviderSelection : undefined}
                            onServiceProviderSelectionChange={(controlValue) => this.onServiceProviderSelectionChanged(controlValue)}
                        />
                        <div className={styles.info}>{t('Select a fleet')}</div>
                        <SoldTosSelectorComponent
                            defaultSoldToSelection={soldToSelection && soldToSelection.value.includes.length > 0 ? soldToSelection : undefined}
                            onSoldToSelectionChange={(controlValue) => this.onSoldToSelectionChanged(controlValue)}
                        />
                    </div>
                    <div className={styles.info}>{t('Select Vehicle Status')}</div>
                    <div className={styles.formRow}>
                        <div className={styles.select}>
                            <label htmlFor="allVehiclesInspection">
                                <input type="radio" id="allVehiclesInspection"
                                       checked={selectedInspectionStatus === InspectionStatus.All}
                                       onChange={() => this.onInspectionStatusChanged(InspectionStatus.All)}
                                />{t('Show all vehicles')}
                            </label>
                            <label htmlFor="notInspectedLastThreeMonths">
                                <input type="radio" id="notInspectedLastThreeMonths"
                                       checked={selectedInspectionStatus === InspectionStatus.NotSeenLastThreeMonths}
                                       onChange={() => this.onInspectionStatusChanged(InspectionStatus.NotSeenLastThreeMonths)}
                                />{t('Only vehicles not seen in the last 3 months')}
                            </label>
                            <label htmlFor="notInspectedLastMonth">
                                <input type="radio" id="notInspectedLastMonth"
                                       checked={selectedInspectionStatus === InspectionStatus.NotSeenLastMonth}
                                       onChange={() => this.onInspectionStatusChanged(InspectionStatus.NotSeenLastMonth)}
                                />{t('Only vehicles not seen last month')}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private onSoldToSelectionChanged(controlValue: SoldToSelectionsControlValue): void {
        const {periodType, onCustomParametersChanged, onScheduledParametersChanged} = this.props;
        const {soldToSelection} = this.state;

        if (!soldToSelection || (soldToSelection && !controlValue.equals(soldToSelection))) {
            this.setState({
                soldToSelection: controlValue,
            },()=>{
                // Make sure previous state has been applied, as service provider and sold to selection changes will trigger at the same time
                const {serviceProviderSelection, selectedInspectionStatus} = this.state;
                if (periodType === ReportPeriodType.Custom) {
                    onCustomParametersChanged({
                        serviceProviders: serviceProviderSelection,
                        soldTos:controlValue,
                        selectedInspectionStatus
                    });
                }
                if (periodType === ReportPeriodType.Scheduled) {
                    onScheduledParametersChanged({
                        inspectionStatus: selectedInspectionStatus,
                        serviceProviders: serviceProviderSelection?.value,
                        soldTos: controlValue.value,
                    });
                }
            });
        }
    }

    private onServiceProviderSelectionChanged(controlValue: ServiceProviderSelectionsControlValue): void {
        const {periodType, onCustomParametersChanged, onScheduledParametersChanged} = this.props;
        const {serviceProviderSelection} = this.state;

        if (!serviceProviderSelection || (serviceProviderSelection && !controlValue.equals(serviceProviderSelection))) {
            this.setState({
                serviceProviderSelection: controlValue,
            },()=>{
                // Make sure previous state has been applied, as service provider and sold to selection changes will trigger at the same time
                const {soldToSelection, selectedInspectionStatus} = this.state;
                if (periodType === ReportPeriodType.Custom) {
                    onCustomParametersChanged({
                        serviceProviders: controlValue,
                        soldTos: soldToSelection,
                        selectedInspectionStatus
                    });
                }
                if (periodType === ReportPeriodType.Scheduled) {
                    onScheduledParametersChanged({
                        inspectionStatus: selectedInspectionStatus,
                        serviceProviders: controlValue.value,
                        soldTos: soldToSelection?.value,
                    });
                }
            });
        }
    }

    private onInspectionStatusChanged(status: InspectionStatus) {
        const {periodType, onCustomParametersChanged, onScheduledParametersChanged} = this.props;
        const {serviceProviderSelection,soldToSelection} = this.state;

        if (periodType === ReportPeriodType.Custom) {
            onCustomParametersChanged({
                serviceProviders: serviceProviderSelection,
                soldTos: soldToSelection,
                selectedInspectionStatus: status
            });
        }
        if (periodType === ReportPeriodType.Scheduled) {
            onScheduledParametersChanged({
                serviceProviders: serviceProviderSelection!.value,
                soldTos: soldToSelection!.value,
                inspectionStatus: status
            });
        }

        this.setState({
            selectedInspectionStatus: status,
        });
    }
}

export default withTranslation()(ExtendedInspectionComponent);

interface OwnProps {
    periodType: ReportPeriodType;
    parameters?: ExtendedInspectionScheduledReportParameters;
    onCustomParametersChanged: (parameters: ExtendedInspectionCustomReportParameters) => void;
    onScheduledParametersChanged: (parameters: ExtendedInspectionScheduledReportParameters) => void;
}

type AllProps = WithTranslation & OwnProps;

interface OwnState {
    selectedInspectionStatus: InspectionStatus;
    serviceProviderSelection?: ServiceProviderSelectionsControlValue;
    soldToSelection?: SoldToSelectionsControlValue;
}

type AllState = OwnState;
